import { lazy } from 'react';
import PageMailwall from './components/pages/PageMailwall'
import PageMailwallOffice365 from './components/pages/PageMailwallOffice365'
import PageOffice365learnmore from './components/pages/PageOffice365learnmore'
import PageMailwallPricing from './components/pages/PageMailwallPricing'
import PageMailwallStartfreetrial from './components/pages/PageMailwallStartfreetrial'
import PageMailwallBookademo from './components/pages/PageMailwallBookademo'
import PageMailwallCloudAntiSpamFiltering from './components/pages/PageMailwallCloudAntiSpamFiltering'
import PageHome from './components/pages/PageHome'

const PageSurfwall = lazy(() => import('./components/pages/PageSurfwall'))
const PageEmailArchiving = lazy(() => import('./components/pages/PageEmailArchiving'))
const PagePhishwise = lazy(() => import('./components/pages/PagePhishwise'))
const PagePrivacyPolicy = lazy(() => import('./components/pages/PagePrivacyPolicy'))
const PageTermsAndConditions = lazy(() => import('./components/pages/PageTermsAndConditions'))
const ContactFormThankYou = lazy(() => import('./components/contact-form/ContactFormThankYou'))
const News = lazy(() => import('./components/news/News'))
const Error404 = lazy(() => import("./components/generic/Error404"))

const routes = [
    { path: "/", component: PageHome},
    { path: "/mailwall-email-filtering", component: PageMailwall},
    { path: "/office365", component: PageMailwallOffice365},
	{ path: "/office365-benefits-features", component: PageOffice365learnmore},
    { path: "/mailwall-Pricing", component: PageMailwallPricing},
    { path: "/mailwall-Startfreetrial", component: PageMailwallStartfreetrial},
    { path: "/mailwall-Bookademo", component: PageMailwallBookademo},
    { path: "/mailwall-cloud-anti-spam-filtering-for-business", component: PageMailwallCloudAntiSpamFiltering},
    { path: "/surfwall-internet-security", component: PageSurfwall},
    { path: "/email-archiving-secure-backup-and-recovery", component: PageEmailArchiving},
    { path: "/phishwise-internet-security-training" , component: PagePhishwise},
    { path: "/privacy-policy" , component: PagePrivacyPolicy},
    { path: "/terms-and-conditions" , component: PageTermsAndConditions},
    { path: "/news/", component: News},
    { path: "/news/:slug", component: News},
    { path: "/contact-form-thank-you", component: ContactFormThankYou},
    { path: "*", component: Error404},
]

export default routes;
